module.exports = __webpack_public_path__ + "img/workshop1-m.04eaeda4.png";